import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LgvPricingModel } from '../../models/pricing.model';

@Component({
    selector: 'lgv-pricing-status-info-dialog',
    templateUrl: './pricing-status-info-dialog.component.html',
    styleUrls: ['./pricing-status-info-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricingStatusInfoDialogComponent implements OnInit {
    pricingStatus: LgvPricingModel.PricingStatus;
    constructor(
        public dialogRef: MatDialogRef<PricingStatusInfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.pricingStatus = data?.pricingStatus;
    }

    ngOnInit(): void {}

    initContent() {}
}
